(function () {
  const formatMoney = (symbol, amount) => {
    const value = Number(amount);
    if (Number.isNaN(value)) return `${symbol}0`;
    const hasCents = Math.abs(value % 1) > 0.001;
    return `${symbol}${value.toLocaleString(undefined, {
      minimumFractionDigits: hasCents ? 2 : 0,
      maximumFractionDigits: 2,
    })}`;
  };

  const initPriceSlider = (root) => {
    if (root.dataset.ahmPriceSliderInit === "true") return;
    root.dataset.ahmPriceSliderInit = "true";

    const minRange = root.querySelector("[data-price-range-min]");
    const maxRange = root.querySelector("[data-price-range-max]");
    const minInput = root.querySelector("[data-price-input-min]");
    const maxInput = root.querySelector("[data-price-input-max]");
    const minDisplay = root.querySelector("[data-price-display-min]");
    const maxDisplay = root.querySelector("[data-price-display-max]");
    const track = root.querySelector(".ahm-price-slider__track");

    if (!minRange || !maxRange || !minInput || !maxInput) return;

    const currency = root.dataset.currencySymbol || "$";
    const rangeMax = parseFloat(root.dataset.rangeMax) || parseFloat(maxRange.max) || 0;
    let debounceTimer = null;

    const bringRangeFront = (activeRange) => {
      minRange.classList.remove("is-active");
      maxRange.classList.remove("is-active");
      activeRange.classList.add("is-active");
    };

    const updateFill = (min, max) => {
      if (!track || rangeMax <= 0) return;
      const leftPct = (min / rangeMax) * 100;
      const rightPct = (max / rangeMax) * 100;
      track.style.setProperty("--ahm-price-min", `${leftPct}%`);
      track.style.setProperty("--ahm-price-max", `${rightPct}%`);
    };

    const syncFacetInputs = (min, max) => {
      minInput.value = min > 0 ? String(min) : "";
      maxInput.value = max < rangeMax ? String(max) : "";

      minInput.setAttribute("data-max", maxInput.value || String(rangeMax));
      maxInput.setAttribute("data-min", minInput.value || "0");

      minDisplay.textContent = formatMoney(currency, min);
      maxDisplay.textContent = formatMoney(currency, max);
      updateFill(min, max);
    };

    const emitFacetUpdate = () => {
      minInput.dispatchEvent(new Event("input", { bubbles: true }));
      minInput.dispatchEvent(new Event("change", { bubbles: true }));
      maxInput.dispatchEvent(new Event("input", { bubbles: true }));
      maxInput.dispatchEvent(new Event("change", { bubbles: true }));
    };

    const applyRanges = (emitUpdate = true, activeRange = null) => {
      let min = parseFloat(minRange.value);
      let max = parseFloat(maxRange.value);
      const active =
        activeRange ||
        (document.activeElement === minRange
          ? minRange
          : document.activeElement === maxRange
            ? maxRange
            : null);

      if (min > max) {
        if (active === minRange) {
          max = min;
          maxRange.value = String(max);
          bringRangeFront(maxRange);
        } else {
          min = max;
          minRange.value = String(min);
          bringRangeFront(minRange);
        }
      }

      syncFacetInputs(min, max);

      if (!emitUpdate) return;
      window.clearTimeout(debounceTimer);
      debounceTimer = window.setTimeout(emitFacetUpdate, 300);
    };

    const bindRangeInteraction = (range) => {
      ["pointerdown", "mousedown", "touchstart", "focus"].forEach((eventName) => {
        range.addEventListener(eventName, () => bringRangeFront(range));
      });
      range.addEventListener("input", () => applyRanges(true, range));
    };

    bindRangeInteraction(minRange);
    bindRangeInteraction(maxRange);

    applyRanges(false);
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll("[data-ahm-price-slider]").forEach(initPriceSlider);
  };

  const watchFacetForms = () => {
    ["FacetFiltersForm", "FacetFiltersFormMobile"].forEach((id) => {
      const form = document.getElementById(id);
      if (!form || form.dataset.ahmPriceSliderWatch === "true") return;
      form.dataset.ahmPriceSliderWatch = "true";
      new MutationObserver(() => initAll(form)).observe(form, {
        childList: true,
        subtree: true,
      });
    });
  };

  const boot = () => {
    initAll();
    watchFacetForms();
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", (event) => {
    initAll(event.target);
    watchFacetForms();
  });
})();
